import baseConfig from '@config/baseConfig';

const phaserConfig = baseConfig();

export const config = {
  width: phaserConfig.width,
  height: phaserConfig.height,
  audio: {},
};

export const gameState = {
  score: 0,
  attempted: 0,
  questionNumber: 0,
  hints: 0,
  gameWin: false,
};

// Cross-scene target positions used by TutorialScene + GameScene.
export const target_1 = new Phaser.Math.Vector2(341.5, 150);
export const target_2 = new Phaser.Math.Vector2(541.5, 150);
export const target_3 = new Phaser.Math.Vector2(741.5, 150);
export const target_4 = new Phaser.Math.Vector2(941.5, 150);
export const dartTarget = new Phaser.Math.Vector2();
